import { ChartOptions } from 'chart.js';
import React, { memo, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import trans from 'translation';
import { KContainer, KLabel } from 'uikit';

const PaymentChart = () => {
  const data = useMemo(() => {
    return {
      synced: 50,
      unsynced: 30,
      failed: 30
    };
  }, []);

  const chartColors = useMemo(() => {
    return ['#13A89E', '#AE0909', '#707277'];
  }, []);

  const chartData = useMemo(() => {
    return {
      labels: ['Synced', 'Unsynced', 'Failed'],
      datasets: [
        {
          data: Object.values(data),
          backgroundColor: chartColors,
          borderWidth: 0
        }
      ]
    };
  }, [data, chartColors]);

  const options: ChartOptions<'doughnut'> = {
    cutout: '60%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    }
  };

  const CenterTextPlugin = {
    id: 'centerText',
    beforeDraw: (chart: any) => {
      const { width } = chart;
      const { height } = chart;
      const ctx = chart.ctx;
      ctx.restore();
      const fontSize = (height / 60).toFixed(2);
      ctx.font = `bold ${fontSize}em sans-serif`;
      ctx.textBaseline = 'middle';

      const total = chart.data.datasets[0].data.reduce(
        (sum: number, value: number) => sum + Number(value),
        0
      );
      const text = total;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillStyle = '#000';
      ctx.fillText(text, textX, textY);
      ctx.save();
    }
  };

  return (
    <KContainer.Card
      height={250}
      dp="flex"
      alignItems="stretch"
      flexG={1}
      header={{
        title: trans('payment_charts'),
        typo: 'TextMdBold'
      }}
    >
      <KContainer.View
        dp="inline-flex"
        direction="column"
        flexG={1}
        alignItems="flex-start"
        marginT="2.5rem"
      >
        <KContainer.View width={100} height={100} flexG={1} marginR="1rem">
          <Doughnut
            data={chartData}
            options={options}
            plugins={[CenterTextPlugin]}
          />
        </KContainer.View>

        <KContainer.View
          dp="flex"
          flexG={1}
          direction="column"
          alignSelf="flex-start"
          marginT="1rem"
        >
          {(chartData?.labels as string[])?.map((label, idx) => (
            <KContainer.View
              key={idx}
              flexG={1}
              dp="inline-flex"
              direction="row"
              alignItems="center"
              marginB="0.5rem"
            >
              <KContainer.View flexG={1} maxW={50}>
                <KContainer.View
                  background={chartColors[idx]}
                  height={12}
                  width={12}
                  marginR="1.5rem"
                />
              </KContainer.View>

              <KLabel.Text width="5rem" flexG={1}>
                {label}
              </KLabel.Text>

              <KLabel.Text flexG={1}>
                {chartData.datasets[0].data[idx]}
              </KLabel.Text>
            </KContainer.View>
          ))}
        </KContainer.View>
      </KContainer.View>
    </KContainer.Card>
  );
};

export default memo(PaymentChart);
